'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _boardConstants = require('../../common/boards/boardConstants');

Object.defineProperty(exports, 'INBOX_STATE', {
  enumerable: true,
  get: function get() {
    return _boardConstants.INBOX_STATE;
  }
});
var INBOX_WIDTH = exports.INBOX_WIDTH = 38;


//////////////////
// WEBPACK FOOTER
// ./src/client/inbox/inboxConstants.js
// module id = 234
// module chunks = 0